const FENCE = /^ {0,3}(`{3,}|~{3,})(.*)$/
const CONTINUES_PREVIOUS_BLOCK = /^(\s|[-*+]\s|\d+[.)]\s)/
const LINK_REFERENCE_DEFINITION = /^ {0,3}\[[^\]]+\]:/m

function closesFence(marker, rest, openMarker) {
  return marker[0] === openMarker[0] && marker.length >= openMarker.length && rest.trim() === ""
}

export function stableMarkdownBoundary(text, from = 0) {
  if (LINK_REFERENCE_DEFINITION.test(text)) return 0

  let boundary = from
  let position = from
  let openFence = ""
  let previousLineBlank = false

  while (position < text.length) {
    const lineEnd = text.indexOf("\n", position)
    if (lineEnd === -1) break

    const line = text.slice(position, lineEnd)
    const fence = line.match(FENCE)
    if (fence && !openFence) {
      if (previousLineBlank) boundary = position
      openFence = fence[1]
      previousLineBlank = false
    } else if (fence && closesFence(fence[1], fence[2], openFence)) {
      openFence = ""
      previousLineBlank = false
    } else if (openFence) {
      previousLineBlank = false
    } else if (line.trim() === "") {
      previousLineBlank = true
    } else {
      if (previousLineBlank && !CONTINUES_PREVIOUS_BLOCK.test(line)) boundary = position
      previousLineBlank = false
    }

    position = lineEnd + 1
  }

  return boundary
}
